import { useStore } from '@/containers'

const currency = (lang: string) => {
  switch (lang) {
    case 'vi':
      return 'VND'
    case 'en':
      return 'USD'
    default:
      return 'VND'
  }
}

export const useCurrencyNumber = () => {
  const { selectedLang } = useStore()

  return (num: number, hideCurrency?: boolean) =>
    num
      .toLocaleString(selectedLang as string, {
        style: 'currency',
        currency: currency(selectedLang as string),
      })
      .replace(/\s₫/g, hideCurrency ? '' : 'đ')
      .replace(/\s\$/g, hideCurrency ? '' : '$')
}

export default useCurrencyNumber
